export const headers = [

  { field: "id", headerName: "ID", width: 40, hide: true },
  { field: "loc_descripcion", headerName: "Descripcion", width: 190 },
  { field: "descripcionProvincia", headerName: "Provincia", width: 190 },
  { field: "descripcionDepartamento", headerName: "Departamento", width: 190 },
  { field: "mostrar", headerName: "Visibilidad", width: 100 },
  ];
  